<template>
  <Modal title="导入结果" width="540" v-model="state" :closable="false" :mask-closable="false" class-name="vertical-center-modal">
    <div class="c-content">
      <p>
        {{ type }}新增成功 <span class="g-success-text">{{ addTotal }}</span> 条，失败
        <span class="g-error-text">{{ failTotal }}</span> 条，更新成功 <span class="g-success-text">{{ updateTotal }}</span> 条！
      </p>
    </div>
    <template slot="footer">
      <div class="m-foot">
        <Button @click="$emit('on-close')">知道了</Button>
        <Button type="primary" v-if="btnFail" @click="$emit('on-down', req)">下载失败的数据</Button>
      </div>
    </template>
  </Modal>
</template>
<script>
export default {
  name: 'resultDialog',
  props: {
    value: {
      type: Boolean
    },
    failTotal: {
      type: Number
    },
    addTotal: {
      type: Number
    },
    updateTotal: {
      type: Number
    },
    type: {
      type: String
    },
    req: {
      type: String
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    btnFail() {
      return this.failTotal > 0
    }
  }
}
</script>
<style lang="scss" scoped>
.c-content {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
